export default "__VITE_ASSET__lKiuieVW__"